var _defs, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUdsmediaassets108(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.35,41.03c-3.35,0-5.54-2.19-5.54-5.56,0-3.88,0-7.75,0-11.62h-12.88c1.35,2.16,2.14,4.71,2.14,7.45,.01,7.71-6.26,14.04-13.94,14.05-.97,0-1.91-.09-2.82-.28,0,10.77,0,21.55,0,32.32,0,2.81,2.28,5.1,5.09,5.1,11.5,0,22.99,0,34.48,0,2.81,0,5.1-2.29,5.1-5.1,0-11.95,0-23.9,0-35.85v-.52h-11.65Zm1.34,28.98c0,1.4-.67,2.07-2.07,2.07-6.64,0-13.29,0-19.93,0-1.4,0-2.07-.67-2.07-2.07v-19.93c0-1.4,.67-2.07,2.07-2.07h19.93c1.4,0,2.07,.67,2.07,2.07v19.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.84,37.59h-.52c-3.38,0-6.75,0-10.13,0-1.27,0-1.94-.67-1.94-1.93,0-3.39,0-6.79,0-10.18v-.46c4.2,4.2,8.38,8.38,12.58,12.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.1,54.85v-3.37h6.8v3.37h-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.23,51.49v3.36h-6.82v-3.36h6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.92,58.37v3.35h-6.82v-3.35h6.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.23,58.37v3.36h-6.8v-3.36h6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.91,65.24v3.36h-6.8v-3.36h6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.22,65.24v3.36h-6.8v-3.36h6.8Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.6,29.8c.01-6.76-5.49-12.3-12.21-12.3-6.84,0-12.38,5.44-12.39,12.18,0,6.93,5.44,12.42,12.33,12.42,6.77,0,12.26-5.49,12.27-12.3Zm-9.46,.69c0,2.17,0,4.34,0,6.5,0,1-.32,1.32-1.29,1.33-1.04,0-2.09,0-3.13,0-.91,0-1.25-.34-1.25-1.25,0-2.19,0-4.38,0-6.56,0-.21,0-.43,0-.71-.56,0-1.08-.01-1.6,0-.46,.01-.86-.09-1.11-.52-.26-.45-.05-.82,.21-1.19,1.47-2.05,2.93-4.11,4.39-6.15,.59-.83,1.29-.83,1.89,0,1.47,2.05,2.93,4.1,4.4,6.15,.25,.35,.44,.71,.22,1.15-.22,.44-.62,.57-1.08,.56-.53,0-1.05,0-1.64,0v.69Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUdsmediaassets108);
export default __webpack_public_path__ + "static/media/UDS MEDIA ASSETS-108.115624c8fb4f17ee42186a59b9dfc5f3.svg";
export { ForwardRef as ReactComponent };